// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "medium-editor/dist/css/medium-editor.min.css";
import "medium-editor/dist/css/themes/beagle.css";
import "vue-search-select/dist/VueSearchSelect.css";
import "cropperjs/dist/cropper.css";
import BootstrapVue from "bootstrap-vue";
import App from "./App";
import router from "./router";
import Lightbox from "vue-my-photos";
import store from "./store/index.js";
import VueGmaps from "vue-gmaps";
import VueMasonry from "vue-masonry-css";
import Flicking from "@egjs/vue-flicking";
import VueTheMask from "vue-the-mask";
import VueLazyload from "vue-lazyload";
import MainStyle from "./assets/css/main.css";
import CustomStyle from "./assets/css/custom.css";
import "./axios";
import imagesBase64 from "../static/json/imagesBase64.json";
import loadingEpics from "./assets/loading/Epics-180-ring-with-bg.svg";

import * as Sentry from "@sentry/vue";
import { Integrations } from "@sentry/tracing";


import "@egjs/vue-flicking/dist/flicking.css";
import "@egjs/flicking-plugins/dist/flicking-plugins.css";

Vue.component("lightbox", Lightbox);

Vue.config.productionTip = false;

Vue.config.productionTip = false;

Vue.use(BootstrapVue);
Vue.use(Lightbox);
Vue.use(VueTheMask);
Vue.use(VueMasonry);
Vue.use(MainStyle);
Vue.use(CustomStyle);
Vue.use(Flicking)

Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: imagesBase64.VueLazyload.error,
  loading: window.location.origin == "https://painel.epics.vc" ? loadingEpics : imagesBase64.VueLazyload.loading,
  attempt: 1
})


Vue.use(VueGmaps, {
  key: "AIzaSyDVgsBOeJgM0qXX82fY3goSQzvMfaUgcMc",
  version: "3"
});

if (process.env.NODE_ENV == "production") {
  Sentry.init({
    Vue,
    dsn: "https://3c7bc28b3b2e424cb16d25039829fffb@o646378.ingest.sentry.io/5891423",
    integrations: [
      new Integrations.BrowserTracing({
        routingInstrumentation: Sentry.vueRouterInstrumentation(router),
        tracingOrigins: [
          "localhost",
          "painel.epics.vc",
          "painel.sitejet.com.br",
          "painel.ulisite.com",
          /^\//
        ]
      })
    ],
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,
  });
}

/* eslint-disable no-new */
const vm = new Vue({
  el: "#app",
  store,
  router,
  template: "<App/>",
  components: { App }
});



// WEBPACK FOOTER //
// ./src/main.js